export const teacherTab = [
    {
        title: '教学名师'
    },
    {
        title: '一流课堂'
    },
    {
        title: '校内建设'
    },
    {
        title: '优秀视频'
    },
]
export const firstClassHeaderTab = [
    '全部',
    '省级一流课程',
    '省级精品课程',
    '省级精品开放课程',
]

export const videoList = {
    code: '',
    data: {
        rowCount: 12,
        list: [
            {
                id: 123,
                menuId: 122,
                videoName: '对头',
                videoCover: 1,
                fileUrl: 1,
                lecturer: 1,
                type: 1,
                status: 1,
                videoDuration: 1,
                dataId: 1,
                organId: 1,
                organName: 1,
                subjectId: 1,
                schoolearId: 1,
                semesterId: 1,
                avatar: 1,
            }
        ]
    }
}